/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiFormationsEventIdGet200Response } from '../models';
/**
 * FormationApi - axios parameter creator
 * @export
 */
export const FormationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get formations by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormationsEventIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiFormationsEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/formations/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormationApi - functional programming interface
 * @export
 */
export const FormationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormationApiAxiosParamCreator(configuration)
    return {
        /**
         * Get formations by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormationsEventIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiFormationsEventIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormationsEventIdGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormationApi.apiFormationsEventIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormationApi - factory interface
 * @export
 */
export const FormationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormationApiFp(configuration)
    return {
        /**
         * Get formations by id from Sportradar API
         * @param {FormationApiApiFormationsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormationsEventIdGet(requestParameters: FormationApiApiFormationsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiFormationsEventIdGet200Response> {
            return localVarFp.apiFormationsEventIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiFormationsEventIdGet operation in FormationApi.
 * @export
 * @interface FormationApiApiFormationsEventIdGetRequest
 */
export interface FormationApiApiFormationsEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormationApiApiFormationsEventIdGet
     */
    readonly eventId: string
}

/**
 * FormationApi - object-oriented interface
 * @export
 * @class FormationApi
 * @extends {BaseAPI}
 */
export class FormationApi extends BaseAPI {
    /**
     * Get formations by id from Sportradar API
     * @param {FormationApiApiFormationsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormationApi
     */
    public apiFormationsEventIdGet(requestParameters: FormationApiApiFormationsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormationApiFp(this.configuration).apiFormationsEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
}

